import { Component, Input } from '@angular/core';
import { OfferForm } from '../../components/offer-form/offer-form';
import { ComponentBase } from '../../intefaces/interfaces';

@Component({
  selector: 'app-header-in-card',
  imports: [OfferForm],
  templateUrl: './header-in-card.html',
  styleUrl: './header-in-card.css'
})
export class HeaderInCard {
  @Input() content!: ComponentBase

}
